import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addStoreSaga,
  deleteStoreSaga,
  editStoreSaga,
  getStoresSaga,
} from "./saga";

export default function* watchStore() {
  yield takeLatest(actionTypes.ADD_STORE, addStoreSaga);
  yield takeLatest(actionTypes.GET_STORES, getStoresSaga);
  yield takeLatest(actionTypes.DELETE_STORE, deleteStoreSaga);
  yield takeLatest(actionTypes.EDIT_STORE, editStoreSaga);
}
